module.exports = __webpack_public_path__ + "static/media/doctor.91e8f30b.png";